import { format, isToday, isYesterday } from 'date-fns';
import { ContactRow } from './contact-row';
import { SearchContactsItem } from '../../../api/api-client';
import clsx from 'clsx';

export const ContactGroup = (props: {
  date: Date;
  contacts: SearchContactsItem[];
  count: number;
  onContactSelect: (contact: SearchContactsItem) => void;
  selectedContactId: string | null;
}) => {
  const getDateLabel = (date: Date) => {
    if (isToday(date)) return 'Today';
    if (isYesterday(date)) return 'Yesterday';
    return format(date, 'EEEE, MMMM d');
  };

  return (
    <div>
      <div
        className={clsx(
          'sticky top-0',
          'flex justify-between items-center h-8 px-4 ',
          'border-neutral-200',
          'bg-white text-sidebar-foreground font-medium'
        )}
      >
        <span className='text-xs text-nowrap'>{getDateLabel(props.date)}</span>
        <span className='text-xs flex items-center gap-1 text-muted-foreground'>
          {props.count} {props.count === 1 ? 'Contact' : 'Contacts'}
        </span>
      </div>
      <div>
        {props.contacts.map((contact) => (
          <ContactRow
            key={contact.id}
            contact={contact}
            onSelect={props.onContactSelect}
            isSelected={props.selectedContactId === contact.id}
          />
        ))}
      </div>
    </div>
  );
};
